import clsx from 'clsx'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useTranslation } from 'react-i18next'

import PublicLayout from '@/components-latest/layout/PublicLayout'
import { buttonVariants } from '@/components-latest/primitives/Button'
import Separator from '@/components-latest/primitives/Separator'
import Text from '@/components-latest/primitives/Text'
import LoginForm from '@/components-latest/ui/LoginPage/LoginForm'
import { PATHS } from '@/config/router/routes'
import { ENVIRONMENT } from '@/constants/env'
import { FOOD_DEPLOYS } from '@/constants/links'

import Styles from './LoginPage.module.scss'

const LoginPage = () => {
  const { t } = useTranslation()
  const { lmd_store_webapp_registration_page } = useFlags()

  return (
    <PublicLayout
      variant="transparent"
      data-testid="login-page"
      className={Styles.loginPage}>
      <div className={Styles.wrapper}>
        <div className={Styles.paper}>
          <Text variant="nextTitle-2" gutter={32}>
            {t('login.page.title')}
          </Text>
          <div className={Styles.content}>
            <LoginForm />
            <div className={Styles.separatorWrapper}>
              <Separator className={Styles.separator} />
              {t('login.separator.label')}
              <Separator className={Styles.separator} />
            </div>

            <a
              href={
                lmd_store_webapp_registration_page
                  ? PATHS.REGISTRATION
                  : `${FOOD_DEPLOYS[ENVIRONMENT]}/restaurant/registration`
              }
              className={clsx(
                Styles.rounded,
                Styles.signUp,
                buttonVariants({ variant: 'tertiary', size: 'large' })
              )}>
              {t('login.ctas.sign-up')}
            </a>
          </div>
        </div>
      </div>
    </PublicLayout>
  )
}

export default LoginPage
